import React, { PureComponent } from 'react';
import PropTypes from 'prop-types'; // ES6
import { TweenMax, TimelineMax, EasePack, TextPlugin} from 'gsap';
import settings from '../../util/settings';

export default class Feature extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
    }
    this.ASSET_PATH = settings.ASSET_PATH + "images/";
  }

  componentWillMount() {
  }

  componentDidMount() {
    this.setImage();
  }

  componentDidUpdate() {
    this.setImage();
  }

  getClasses = () => {
    return this.props.className ? " " + this.props.className : "";
  }

  setImage = () => {
    if (this.props.image) {
      TweenMax.to(this.FeatureImage, 0.25, {autoAlpha: 0});
      TweenMax.set(this.FeatureImage, {backgroundImage: "url(" + this.ASSET_PATH + this.props.image + ")"});
      TweenMax.to(this.FeatureImage, 0.25, {autoAlpha: 0.8});
    }
  }

  processSubtitle = () => {
    if (this.props.subtitle) {
      var arr = this.props.subtitle.split(" ")
      if (arr.length > 4) {
        var part1 = arr.slice(0, arr.length/2).join(" "),
            part2 = arr.slice(arr.length/2).join(" "),
            offset = 0;

        // Ensures bottom line is longer than - or equal to - top line
        while (part1.length > part2.length) {
          offset += 1;
          part1 = arr.slice(0, (arr.length/2) - offset).join(" ")
          part2 = arr.slice((arr.length/2) - offset).join(" ")
        }

        return <p className="feature-subtitle">{part1}<br/>{part2}</p>
      } else {
        return <p className="feature-subtitle">{this.props.subtitle}</p>
      }
    }
  }

  getSubtitle = subtitle => {
    return subtitle.replace(/\\n/ig, '<br/>')
  }

  render() {
    const clickable = this.props.clickable ? 'clickable' : 'non-clickable';
    const subtitle = this.props.subtitle ? this.props.subtitle.split('\n').join('<br/>') : []
    
    return (
      <div className={`Feature ${clickable}` + this.getClasses()} ref={el => this.Feature = el}>
        { this.props.image &&
          <div className={`feature-img ${clickable}`} ref={el => this.FeatureImage = el} />
        }
        <p className={`feature-title ${clickable} ${!this.props.image ? " noimage" : ""}`}>{this.props.title}</p>
        { subtitle.length > 0 &&
          <p className={"feature-subtitle" + (!this.props.image ? " noimage" : "")} dangerouslySetInnerHTML={{ __html: subtitle}}></p>
        }
      </div>
    );
  }
}

Feature.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  image: PropTypes.string,
  className: PropTypes.string
};

Feature.defaultProps = {
  title: "Title"
};



// WEBPACK FOOTER //
// ./components/Feature/Feature.js